import {getMethod, postMethod, putMethod, patchMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownExtraServiceContracts', request)
}

async function post(request) {
    return await postMethod('/api/ownExtraServiceContracts', request)
}

async function put(request) {
    return await putMethod('/api/ownExtraServiceContracts', request)
}

async function patch(id, request) {
    return await patchMethod(`/api/ownExtraServiceContracts/${id}`, request)
}

export {get, post, put, patch}
